import * as types from './actionTypes';
import {ajaxCallError} from './ajaxStatusActions';
import {Api} from '../api/Api';
import {beginAjaxCall, sinReducerSuccess} from './ajaxStatusActions';


export function saveHomecatSuccess(home) {
  return {type: types.SAVE_HOME_CAT_SUCCESS, datos:home};
}



export function save(homecat,  token ) {
    
	return dispatch => {
		      dispatch(beginAjaxCall());
		      return Api().HomecatApi.saveHomecat( homecat,  token).then(homecat => {                  
                  dispatch(saveHomecatSuccess(homecat));
                  return homecat;
		      }).catch(error => {
		          dispatch(ajaxCallError());
		  throw(error);
		});
  	};
}


export function getHomecatSuccess() {
  return {type: types.GET_HOME_CAT_SUCCESS};
}



export function getHomecat(token ) {
    
	return dispatch => {
		      dispatch(beginAjaxCall());
		      return Api().HomecatApi.getHomecat(  token).then(homecat => {                  
                  dispatch(getHomecatSuccess(homecat));
                  return homecat;
		      }).catch(error => {
		          dispatch(ajaxCallError());
		  throw(error);
		});
  	};
}



export function getImagenes(token ) {
    
	return dispatch => {
		      dispatch(beginAjaxCall());
		      return Api().HomecatApi.getImagenes(token).then(homeImagenes => {                  
                  dispatch(getHomecatSuccess(homeImagenes));
                  return homeImagenes;
		      }).catch(error => {
		          dispatch(ajaxCallError());
		  throw(error);
		});
  	};
}


export function delteImagen(id, token ) {
    
	return dispatch => {
		      dispatch(beginAjaxCall());
		      return Api().HomecatApi.delteImagen(id, token).then(homeImagenes => {                  
                  dispatch(getHomecatSuccess(homeImagenes));
		      }).catch(error => {
		          dispatch(ajaxCallError());
		  throw(error);
		});
  	};
}



export function saveImagen(datos, token) {
  return dispatch => {
	dispatch(beginAjaxCall());  
        return Api().HomecatApi.saveImagen(datos, token).then((foto) => {            
        dispatch(sinReducerSuccess(foto.descripcion));   
         return foto;    
    }).catch(error => {
		dispatch(ajaxCallError()); 
      throw(error);
    });
  };
}
